import React, { Component } from "react";
import { connect } from "react-redux";
import "./GroupSelect.css";

class GroupSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
      selectedGroup: null,
      selectedVehicles: [],
      isOpen: false,
    };
    window.downloadForAll = false
  }

  handleClickOutside = (e) => {
    if(this.refs.groupSelect && !this.refs.groupSelect.contains(e.target)){
        this.setState({isOpen:false})
    }
  }
  componentDidMount() {
    window.selectedGroup = []
    window.downloadForAll = false

    window.addEventListener("mousedown", this.handleClickOutside)
  }
  
  handleToggleDropdown = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  handleSearch = (event) => {
    this.setState({ searchTerm: event.target.value, isOpen: true });
  };

  handleSelectGroup = (groupName) => {
    window.downloadForAll = false

    const { groupTree } = this.props;
    const selectedGroup = this.findGroup(groupTree, groupName);
    window.selectedGroup = selectedGroup ? selectedGroup || [] : []

    this.setState({
      selectedGroup: selectedGroup ? selectedGroup.name : null,
      selectedVehicles: selectedGroup ? selectedGroup.vehicles || [] : [],
      isOpen: false,
      searchTerm:selectedGroup ? selectedGroup.name : ""
    });
  };

  handleSelectAll = () => {
    window.downloadForAll = true
    this.setState({
      selectedGroup: "All Vehicles",
      searchTerm: "All Vehicles",
      isOpen: false,
    });
  };

  findGroup = (group, name) => {
    if (group.name === name) return group;
    if (group.children && Array.isArray(group.children)) {
      for (let child of group.children) {
        const found = this.findGroup(child, name);
        if (found) return found;
      }
    }
    return null;
  };

  filterGroups = (group, searchTerm) => {
    if (!group || typeof group !== "object") return [];
    const lowerSearchTerm = searchTerm.toLowerCase();
    let matchedGroups = [];

    if (group.name.toLowerCase().includes(lowerSearchTerm)) {
      matchedGroups.push({ name: group.name, vehicles: group.vehicles || [] });
    }

    if (group.children && Array.isArray(group.children)) {
      group.children.forEach((subGroup) => {
        matchedGroups = matchedGroups.concat(this.filterGroups(subGroup, searchTerm));
      });
    }

    return matchedGroups;
  };

  getAllGroups = (group) => {
    if (!group || typeof group !== "object") return [];
    let allGroups = [];
    if(group.groupid !== 0) 
     allGroups = [{name: group.name}]

    if (group.children && Array.isArray(group.children)) {
      group.children.forEach((subGroup) => {
        allGroups.push(...this.getAllGroups(subGroup));
      });
    }
    return allGroups;
  };

  render() {
    const { groupTree } = this.props;
    const { searchTerm, selectedGroup, isOpen } = this.state;

    const filteredGroups = searchTerm
      ? this.filterGroups(groupTree, searchTerm)
      : this.getAllGroups(groupTree);

    return (
      <div className="group-select" ref ="groupSelect">
        <div className="dropdown-header">
          <input
            type="text"
            placeholder="Search group"
            value={searchTerm}
            onChange={this.handleSearch}
            onClick={this.handleToggleDropdown}
          />
        </div>

        {isOpen && (
          <div className="dropdown-menu">
            { !searchTerm.length ? <div className="dropdown-option select-all" onClick={this.handleSelectAll}>
              All Vehicles
            </div>:null}
            {filteredGroups.length > 0 ? (
              filteredGroups.map((group, index) => (
                <div key={index} className="dropdown-option" onClick={() => this.handleSelectGroup(group.name)}>
                  {group.name}
                </div>
              ))
            ) : (
              <div className="dropdown-option">No groups found</div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  groupTree: state.groupTree,
});

export default connect(mapStateToProps)(GroupSelect);
